'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useValue;

var _react = require('react');

var _Contexts = require('./Contexts');

function useValue() {
  return (0, _react.useContext)(_Contexts.ValueContext);
}